import "./index.scss";
import dictionary from "../../dictionary";
type Props = {
  onClick?: (item: string) => void;
};

const BreadCrumb = ({ onClick }: Props) => {
  const items = window.location.pathname.split("/").filter((path) => path.length > 0);
  return (
    <div id="bread-crumb-container">
      {items.map((item, index) =>
        items.length - 1 > index ? (
          <div className="direction-name" key={index}>
            <span>{dictionary.breadcrumbDictionary(item)}</span>

          </div>
        ) : (
          <div className="main-page-name" key={index}>
            <span>{dictionary.breadcrumbDictionary(item)}</span>
          </div>
        )
      )}
    </div>
  );
};

export default BreadCrumb;
